"use client";

import { LazyMotion, domAnimation } from "framer-motion";
import { ReactNode } from "react";

/**
 * Lazy framer-motion feature provider.
 *
 * framer's `motion.*` proxy eagerly bundles ALL features — including the
 * heavy layout-projection + drag/pan code (create-projection-node,
 * VisualElementDragControls, PanSession) that PageSpeed flagged as unused
 * JS on the homepage. We use none of it: every animation here is plain
 * initial/animate/whileInView/whileHover/whileTap (+ AnimatePresence).
 *
 * Switching those call sites to the lightweight `m.*` component and
 * supplying just `domAnimation` here loads only the animation + gesture
 * features once, app-wide. Same animations, much less JS to parse/execute
 * on hydration (the ~2s scriptEvaluation that became the score ceiling
 * once the 3D render loop was fixed).
 *
 * Not `strict`: other routes (about / work / scope / forest) still use the
 * full `motion` for now, which coexists fine — it just brings its own
 * features and ignores this context.
 */
const MotionProvider = ({ children }: { children: ReactNode }) => (
  <LazyMotion features={domAnimation}>{children}</LazyMotion>
);

export default MotionProvider;
